<template>
  <div class="teacher">
    <Form ref="optionForm" :model="searchCondition" :label-width="70" inline>
      <FormItem label="用户账号">
        <Input
          type="number"
          v-model="searchCondition.mobile"
          placeholder="请输入用户账号，即手机号"
          style="width: 200px"
          clearable
          @keydown.native.prevent.enter="onSearch"
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onAdd" class="btn-margin-right">
        新增课程有效期
      </Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/validity/course_validity"
        :search="searchCondition"
        :rowsFormatter="onRowsFormatter"
        selectType="single"
        keyField="id"
        method="get"
      >
        <template slot-scope="{ row }" slot="c1">
          <div class="vmiddle">
            <img class="table-avatar" :src="row.avatar" />
            <span v-text="row.real_name"></span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <Button type="text" size="small" @click="onEdit(row)">编辑</Button>
            <span>-</span>
            <Button type="text" size="small" @click="onDelete(row)">
              删除
            </Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>

<script>
export default {
  name: "course_validity",
  components: {},
  data() {
    return {
      searchCondition: {
        mobile: "",
        init: function () {
          this.mobile = "";
        },
      },
      tableColumns: [
        {
          title: "用户账号",
          key: "user_mobile",
          align: "center",
          minWidth: 150,
        },
        { title: "课程", key: "course_name", align: "center", minWidth: 100 },
        { title: "有效期", key: "expired_at", align: "center", minWidth: 100 },
        {
          title: "订单编号",
          key: "order_number",
          align: "center",
          minWidth: 100,
        },
        {
          title: "更新时间",
          key: "updated_at",
          align: "center",
          minWidth: 150,
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 200,
          fixed: "right",
        },
      ],
      selectRows: [],
    };
  },
  created() {},
  methods: {
    // on-event
    onRowsFormatter(rows) {
      rows.forEach((i) => {
        i.updated_at = this.$pub.timestampToTime(i.updated_at);
        i.expired_at = this.$pub.timestampToTime(i.expired_at);
      });
    },
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onAdd() {
      this.$router.push({
        name: "CourseValidityEdit",
      });
    },
    onEdit(row) {
      this.$router.push({
        name: "CourseValidityEdit",
        query: {
          id: row.id,
        },
      });
    },
    onDelete(row) {
      this.$Modal.confirm({
        title: "提示",
        content: "确定要删除选定课程有效期吗？",
        onOk: () => {
          this.$http
            .delete("/api/validity/course_validity/" + row.id)
            .then(() => {
              this.$Message.success("删除成功");
              this.$refs.grid.refresh();
            });
        },
      });
    },
  },
};
</script>
